import { Chip } from '@mui/material';
import { WORK_ORDER_STATUS, WorkOrderStatus } from 'vendor-marketplace-shared-library';

import theme from '../../utilities/theme';

type WorkOrderStatusChipProps = {
  workOrderStatus: WorkOrderStatus;
};

export default function WorkOrderStatusChip(props: WorkOrderStatusChipProps) {
  const determineStatusColor = (workOrderStatus: WorkOrderStatus) => {
    switch (workOrderStatus.name) {
      case WORK_ORDER_STATUS.OPEN.name:
        return 'secondary.light';
      case WORK_ORDER_STATUS.IN_PROGRESS.name:
        return `${theme.palette.info.main}1A`;
      case WORK_ORDER_STATUS.ON_HOLD.name:
        return 'customGrey.main';
      case WORK_ORDER_STATUS.DONE.name:
        return `${theme.palette.success.main}1A`;
    }
  };

  const determineTextColor = (workOrderStatus: WorkOrderStatus) => {
    switch (workOrderStatus.name) {
      case WORK_ORDER_STATUS.OPEN.name:
        return 'text.primary';
      case WORK_ORDER_STATUS.IN_PROGRESS.name:
        return 'info.main';
      case WORK_ORDER_STATUS.ON_HOLD.name:
        return 'text.primary';
      case WORK_ORDER_STATUS.DONE.name:
        return 'success.main';
    }
  };

  return (
    <Chip
      label={props.workOrderStatus.name}
      sx={{
        ...Styles.chip,
        backgroundColor: determineStatusColor(props.workOrderStatus),
        color: determineTextColor(props.workOrderStatus),
      }}
    />
  );
}

const Styles = {
  chip: {
    borderRadius: 1,
    p: 0.1,
    cursor: 'pointer',
  },
};
